import React from 'react'
import MenuDropdownIcon from '../../icons/menuDropdown'

import assetsPath from '../../../../common/utils/assetsPath'

export default ({envatoProducts, envatoProductsStaticLinks}) => {
  return (
    <li className='global-header-menu__list-item--with-dropdown'>
      <a href='#' className='global-header-menu__link'>
        <MenuDropdownIcon className='global-header-menu__icon'
          width='16px' height='16px' />
        <span className='global-header-menu__link-text'>
          Our Products
        </span>
      </a>

      <div className='global-header-menu__dropdown-container'>
        <div className='global-header-dropdown'>
          <ul className='global-header-dropdown__list'>
            {
              envatoProducts.map((product) => {
                const productLogoPath = assetsPath() + product.logo
                return (
                  <li key={product.key}>
                    <a href={product.url}
                      className='global-header-dropdown__link'
                      target='_blank'>
                      <img className='global-header-dropdown__product-logo'
                        src={productLogoPath}
                        alt={product.name} />
                      {
                        product.description
                        ? (<span className='global-header-dropdown__link-text -decoration-none'>
                          {product.description}
                        </span>) : null
                       }
                    </a>
                  </li>
                )
              })
            }
          </ul>

          <div className='global-header-dropdown-footer'>
            <ul>
              {
                envatoProductsStaticLinks.map((link) => {
                  return (
                    <li key={link.key}
                      className='global-header-dropdown-footer__list-item'>
                      {link.label}
                      <a href={link.url}
                        className='global-header-dropdown-footer__link'
                        target='_blank'>
                        {link.linkLabel}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/envatoProducts.js